<div class="height">
    <div class="d-flex flex-column justify-content-center align-items-center">
        <img src="assets/images/menuLogo/Afrisurelogo.svg" alt="App Logo" class="mb-3 app-logo">
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center height">
        <img *ngIf="status==1" src="assets/svg/process.gif" alt="WhatsApp Success Icon" class="process-gif">
        <img *ngIf="status==3" src="assets/svg/fail.gif" alt="WhatsApp Success Icon" class="success-gif">
        <img *ngIf="status==2" src="assets/svg/successs.gif" alt="WhatsApp Success Icon" class="process-gif">
        <p *ngIf="status==1" class="mt-5 text-warning">Validation is currently being processed.</p>
        <p *ngIf="status==3" class="mt-5 text-danger">Something went wrong during the process. </p>
        <p *ngIf="status==2" class="mt-5 text-success">The validation was completed successfully.</p>
    </div>
</div>